var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-grid",style:({
    'grid-template-rows':    `repeat(${_vm.rows}, ${_vm.cellSize}px)`,
    'grid-template-columns': `repeat(${_vm.columns}, ${_vm.cellSize}px)`,
  })},_vm._l((_vm.table),function(cell,index){return _c('board-cell',{key:`${cell.positiony}-${cell.positionx}`,style:({ width: _vm.cellSize + 'px', height: _vm.cellSize + 'px' }),attrs:{"cell":cell,"cell-size":_vm.cellSize,"settings":_vm.settings,"data-index":index},on:{"click":function($event){return _vm.$emit('cell-click', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }